module.exports = __webpack_public_path__ + "static/media/Icon-Actor.cdcc6c82.png";